import { render, staticRenderFns } from "./MenuItemShell.vue?vue&type=template&id=271a64c6"
import script from "./MenuItemShell.vue?vue&type=script&lang=js"
export * from "./MenuItemShell.vue?vue&type=script&lang=js"
import style0 from "./MenuItemShell.vue?vue&type=style&index=0&id=271a64c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports